import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useRef } from "react";
import { textPlaceHolder } from "../../../helpers/placeholders";
import replacePlaceholders from "../../../helpers/replacePlaceholders";
import { useSite } from "../../../hooks/SiteProvider";
import useRepeatableRepeater from "../../../hooks/draggables/useRepeatableRepeaterFieldProps";
const DraggableText = ({ item: { props, id }, elementId, ...rest }) => {
    const { textPlaceholders } = useSite();
    const articleRef = useRef(null);
    const { value: repeatableRepeaterTextValue } = useRepeatableRepeater({
        type: "text",
        repeatableId: props?.repeatableRepeater,
        repeatableItemId: props?.repeatableRepeaterItem,
        identifier: props?.repeatableRepeaterText?.repeatableField,
    });
    const renderText = useCallback(() => {
        if (props?.repeatableRepeaterText?.type) {
            return repeatableRepeaterTextValue;
        }
        return (replacePlaceholders(props?.text, textPlaceholders) ||
            textPlaceHolder.value);
    }, [props?.text, textPlaceholders, repeatableRepeaterTextValue]);
    useEffect(() => {
        const articleElement = articleRef.current;
        if (articleElement) {
            const pElements = articleElement.querySelectorAll("p");
            pElements.forEach((pElement) => {
                pElement.setAttribute("editor-key", id);
            });
        }
    }, []);
    return (_jsx("article", { className: props?.className || "prose max-w-none", "editor-key": id, ...rest, ref: articleRef, "editor-text-type": props?.repeatableRepeaterText?.type, "editor-text-repeatable-field": props?.repeatableRepeaterText?.repeatableField, dangerouslySetInnerHTML: {
            __html: renderText(),
        } }));
};
export default DraggableText;
//# sourceMappingURL=DraggableText.js.map